var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFireBrightGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fireBright"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f39a67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#f26d81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d283d9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireBrightGradient);
export default __webpack_public_path__ + "static/media/fireBrightGradient.088cbc3f944232278df9854052035616.svg";
export { ForwardRef as ReactComponent };